import React, { useEffect, useState, useRef } from "react";
import { useHistory, Link } from 'react-router-dom';
import { Button, Col, Container, Row } from "react-bootstrap";
import { useQuery } from "components/HRInduction/Shared/Helpers";
import CustomSweetAlert from "components/Shared/CustomSweetAlert";
import PdfViewComponent from "components/Onboarding/PdfViewComponent";
import VideoViewComponent from "components/Onboarding/VideoViewComponent";

function OnboardingWizard(props) {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const { employeeId, inductionId } = useQuery();
    const history = useHistory();
    const [alert, setAlert] = useState(null);
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [videoData, setVideoData] = useState({
        key: "video1",
        isCompleted: false,
        link: "https://player.vimeo.com/video/864032391?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        text: "H&S video",
        postAPI: "",
    });
    const [inductionPDFItem, setInductionPDFItem] = useState(null);
    const [inductionVideoItem, setInductionVideoItem] = useState(null);

    useEffect(() => {
        fetchInductionInformation();
    }, []);

    const fetchInductionInformation = async () => {
        try {
            const url = `/Onboarding/GetSingle?empId=${employeeId}`;
            const response = await fetch(apiURL + url)
            if (response.ok) {
                const fetchData = await response.json();
                if (fetchData) {
                    setData(fetchData);
                    setVideoData(prev => ({
                        ...prev, isCompleted: fetchData.completedHSVideo,
                        postAPI: `/Onboarding/CompleteHSVideo?empId=${fetchData.empId}`
                    }));
                    const pdfInductions = [
                        {
                            key: "leanPrinciples",
                            isCompleted: fetchData?.completedTBT227,
                            link: require("assets/pdf/TBT0227_Lean_Principles.pdf").default,
                            text: "Lean Principles",
                            postAPI: `/Onboarding/CompleteTBT227?empId=${fetchData.empId}`,
                        },
                        {
                            key: "dignityAtWork",
                            isCompleted: fetchData?.completedTBT228,
                            link: require("assets/pdf/TBT0228_Dignity_at_Work.pdf").default,
                            text: "Dignity at Work",
                            postAPI: `/Onboarding/CompleteTBT228?empId=${fetchData.empId}`,
                        },
                        {
                            key: "humanTrafficking",
                            isCompleted: fetchData?.completedTBT259,
                            link: require("assets/pdf/TBT0259_Modern_Slavery&Human_Trafficking.pdf").default,
                            text: "Modern Slavery & Human Trafficking",
                            postAPI: `/Onboarding/CompleteTBT259?empId=${fetchData.empId}`,
                        }
                    ];
                    setPdfData(pdfInductions);
                }
            } else {
                showErrorAlert(` No HR Induction found for EmployeeId:[${employeeId}]`);
            }
        } catch (err) {
            showErrorAlert(`Failed to fetch data`);
        }
    };

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    const handleRedirect = (url) => {
        history.push(url);
    }

    const InductionLink = ({ induction, onClick, }) => {
        const { isCompleted, text } = induction;
        const textColor = isCompleted !== null ? "#87cb16" : "#888888";
        const iconClass = isCompleted !== null ? "fa-check-square" : "fa-square";
        return (
            <Row>
                <Col>
                    <Button
                        className={`btn-link d-flex justify-content-start `}
                        size="lg"
                        style={{ margin: "0px", padding: "0px", color: textColor, textDecoration: "none" }}
                        onClick={onClick}
                    >
                        <i className={`far ${iconClass} mx-3 align-self-center`}></i>
                        <p style={{ fontSize: "17px", marginBottom: 0 }}>{text}</p>
                    </Button>
                </Col>
            </Row>
        )
    };

    const handleInductionShow = (induction, type) => {
        handleNextStep();
        if (type === "video") {
            setInductionVideoItem(induction);
        } else {
            setInductionPDFItem(induction);
        }
    }

    const handleClosePDF = (key) => {
        const data = pdfData.map((item) => item.key === key ? { ...item, isCompleted: true } : item);
        setPdfData(data);
        handleNextStep();
    }

    const handleCloseVideo = () => {
        const data = { ...videoData, isCompleted: !videoData.isCompleted }
        setVideoData(data);
        handleNextStep();
    }

    const handleNextStep = () => {
        setInductionPDFItem(null);
        setInductionVideoItem(null);
    }

    return <>
        {alert}
        <Container fluid className="h-100" >
            <Container fluid className="wizard wizard-full-width hs-induction-wizard p-4">
                {isLoading ? <>HI</> :
                    <Row>
                        <Col lg="5" md="12" sm="12" xs="12">
                            <h2 style={{ marginTop: "0px" }}> Welcome <span><strong>{data?.employeeName}</strong></span> to your FP McCann onboarding</h2>
                            <span>Please complete the steps below:</span>

                            <ul className="list-group list-group-flush">
                                {data?.sendHR === true ?
                                    <li className="list-group-item">
                                        <InductionLink
                                            induction={{
                                                isCompleted: data?.completedHR,
                                                text: "HR Induction"
                                            }}
                                            onClick={() => handleRedirect(`/onboarding/hrInduction?employeeId=${employeeId}&inductionId=${inductionId}&pin=${data?.pin}&lastCompletedStep=1`)}
                                        />
                                    </li>
                                    : <></>}
                                {data?.sendTBT === true ?
                                    <li className="list-group-item">
                                        <Row>
                                            <Col>
                                                <p style={{ fontSize: "17px", marginBottom: 0, marginLeft: "16px" }}>Toolbox talks</p>
                                            </Col>
                                        </Row>
                                        <div style={{ paddingLeft: "35px" }}>
                                            {pdfData && pdfData?.map((pdfInduction, index) =>
                                                <InductionLink key={index} induction={pdfInduction} onClick={() => handleInductionShow(pdfInduction, "pdf")} />
                                            )}
                                        </div>
                                    </li>
                                    : <></>}
                                {data?.sendHSVideo === true ?
                                    <li className="list-group-item">
                                        <InductionLink induction={videoData} onClick={() => handleInductionShow(videoData, "video")} />
                                    </li>
                                    : <></>}
                                {data?.sendHS === true ?
                                    <li className="list-group-item">
                                        <InductionLink
                                            induction={{
                                                isCompleted: data?.completedHS,
                                                text: "Pre-Employment Health Questionnaire"
                                            }}
                                            onClick={() => handleRedirect(`/onboarding/hsInduction?employeeId=${employeeId}&inductionId=${inductionId}&pin=${data?.pin}&lastCompletedStep=1`)}
                                        />
                                    </li>
                                    : <></>}
                            </ul>
                        </Col>
                        <Col lg="7" md="12" sm="12" xs="12">
                            {inductionPDFItem && <PdfViewComponent inductionItem={inductionPDFItem} maxHeight={500} handleClose={handleClosePDF} />}
                            {inductionVideoItem && <VideoViewComponent inductionItem={inductionVideoItem} maxHeight={500} handleClose={handleCloseVideo} />}
                        </Col>
                    </Row>
                }
            </Container>
        </Container >
    </>
}

export default OnboardingWizard;